import type React from 'react'

import { Box } from '@fortum/elemental-ui'

type AriaLiveRegionProps = {
  children: React.ReactNode
  visuallyHidden?: boolean
  politeness?: 'assertive' | 'polite'
}
/**
 * A component to show a live region for screen readers
 * @param politeness - 'assertive' for critical updates that should interrupt (default), 'polite' for less urgent updates
 */
export const AriaLiveRegion = ({
  children,
  visuallyHidden = true,
  politeness = 'assertive',
}: AriaLiveRegionProps) => {
  return (
    <Box
      role="status"
      aria-live={politeness}
      style={
        visuallyHidden
          ? {
              position: 'absolute',
              left: '-9999px',
              height: '1px',
              width: '1px',
              overflow: 'hidden',
            }
          : undefined
      }
    >
      {children}
    </Box>
  )
}
